import { Box } from '@mui/material'
import { css } from '@emotion/react'
import styled from '@emotion/styled'

export const Container = styled(Box)`
  width: 100%;
  padding: 10px;

  /* MUI foca este nó (tabIndex=-1) ao abrir o Modal, como fallback de acessibilidade do
     FocusTrap — sem isto o navegador desenha o outline padrão de foco nesta faixa de 20px
     no topo da viewport. */
  outline: none;
`

export const Wrapper = styled(Box)`
  ${({ theme }) => css`
    width: 100%;
    border-radius: 10px;
    background-color: ${theme.colors.lightest};
    box-shadow: ${theme.colors.shadows.header};
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    display: flex;
    flex-direction: column;
    overflow: hidden;
  `}
`

export const Header = styled(Box)`
  padding: 24px 24px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-shrink: 0;
`

export const TitleBox = styled(Box)`
  ${({ theme }) => css`
    font-size: 20px;
    font-style: normal;
    font-weight: 600;
    line-height: 100%;
    color: ${theme.colors.secondary};
    display: flex;
    align-items: center;
    gap: 4px;

    svg {
      width: 20px;
      height: 20px;
      margin-bottom: 2px;
    }

    @media (max-width: ${theme.screenSizes.tablet}) {
      max-width: 90%;
    }
  `}
`

export const CloseIcon = styled(Box)`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    justify-content: center;

    svg {
      color: ${theme.colors.secondary};
      cursor: pointer;
    }
  `}
`

export const Content = styled(Box)<{ hasFooter: boolean }>`
  padding: 16px 24px 24px;
  overflow-y: auto;
  flex: 1 1 auto;
  border-radius: 0 0 10px 10px;
  position: relative;

  ${({ hasFooter }) =>
    hasFooter &&
    css`
      padding-bottom: 24px;
    `}
`

export const Footer = styled(Box)<{ $actionsAlign?: 'center' | 'end' }>`
  padding: 24px;
  display: flex;
  gap: 16px;
  flex-shrink: 0;
  justify-content: ${({ $actionsAlign }) => ($actionsAlign === 'center' ? 'center' : 'flex-end')};
  z-index: 1100;
`

export const LoaderBox = styled(Box)`
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.63);
  z-index: 10;
`
